import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, hasRank } from '../hooks/useAuth';
import { PageLoader } from './ui/Spinner';
import { useT } from '../i18n';

export function ProtectedRoute({ minRank = 10 }: { minRank?: number }) {
  const { data: user, isLoading, isError } = useAuth();
  const location = useLocation();
  const t = useT();

  if (isLoading) return <PageLoader />;
  if (isError || !user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!hasRank(user, minRank)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-slate-500">{t('access.denied')}</p>
      </div>
    );
  }
  return <Outlet />;
}
